// src/components/transfers/LogsDialog.jsx
import React from 'react';
import { X } from 'lucide-react';

const LOG_ACTION_MAP = {
  edit_quantity: '修改数量', add_item: '新增商品', remove_item: '删除商品',
};

const LogsDialog = ({ transferNo, logs, loading, onClose }) => (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[80vh] flex flex-col">
      <div className="p-6 border-b flex justify-between items-center">
        <div>
          <h3 className="text-lg font-bold">修改记录</h3>
          <p className="text-xs text-gray-500 mt-0.5">{transferNo}</p>
        </div>
        <button onClick={onClose} className="text-gray-400 hover:text-gray-600"><X className="w-6 h-6" /></button>
      </div>
      <div className="p-6 overflow-y-auto flex-1">
        {loading ? (
          <div className="text-center py-8 text-gray-400">加载中...</div>
        ) : logs.length === 0 ? (
          <div className="text-center py-8 text-gray-400">暂无修改记录</div>
        ) : (
          <div className="space-y-3">
            {logs.map(log => (
              <div key={log.id} className="flex gap-3 p-3 bg-gray-50 rounded-xl">
                <div className="w-8 h-8 rounded-full bg-yellow-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-sm">✏️</span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between">
                    <span className="text-sm font-medium text-gray-800">{log.operator_name || '未知用户'}</span>
                    <span className="text-xs text-gray-400">{new Date(log.created_at).toLocaleString('zh-CN')}</span>
                  </div>
                  <p className="text-sm text-gray-600 mt-0.5">
                    <span className="font-medium text-blue-600">{LOG_ACTION_MAP[log.action] || log.action}</span>
                    {log.product_name && <span className="ml-1">「{log.product_name}」</span>}
                  </p>
                  {(log.old_value || log.new_value) && (
                    <p className="text-xs text-gray-400 mt-0.5">
                      {log.old_value && <span className="line-through mr-2">{log.old_value}</span>}
                      {log.new_value && <span className="text-green-600">→ {log.new_value}</span>}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  </div>
);

export default LogsDialog;
